import Utils from "../Misc/Utils.js";

export default class InputHelper
{
    static get KeyCodes()
    {
        return Phaser.Input.Keyboard.KeyCodes;
    }

    static get LetterKeyCodes() { return Array(26).fill().map((e, i) => i + 65); }
    static get NumberKeyCodes() { return Array(10).fill().map((e, i) => i + 48).concat(Array(10).fill().map((e, i) => i + 96)).concat([190, 110]) }

    /**
     * @param {InputHelper.KeyCodes} keyCode 
     */
    static Listen(keyCode, func, event = 'keydown')
    {
        if (!Utils.scene) return;

        if (this.handler == null)
        {
            this.events = [];
            this.handler = (e) =>
            {
                this.events.forEach((event) =>
                {
                    if (event.keyCode === e.keyCode) event.handler();
                });
            };

            Utils.scene.input.keyboard.on('keydown', this.handler);
            Utils.scene.sys.events.on("shutdown", () =>
            {
                this.events = null;
                this.handler = null;
                Utils.scene.input.keyboard.off('keydown', this.handler);
            });
        }

        if (this.events.filter((e) => { return e.keyCode == keyCode }).length == 0) this.events.push({ keyCode: keyCode, handler: func });
    }


    /**
     * NOTE: NOT FULLY TESTED!!!
    * @param {function(number, number, number, number, number, number)} onDrag (deltaX, deltaY, x, y, time, deltaTime)
    * @param {function(number, number, number, number)} onDragEnd (deltaX, deltaY, x, y)
    */
    static OnMouseInput(onDrag = null, onDragEnd = null)
    {
        let scene = Utils.scene;
        let activePointer = scene.input;

        var getPos = () =>
        {

            return { x: activePointer.x, y: activePointer.y }
        };
        let onDown = () =>
        {
            initialInputPos = getPos();
            inputDown = true;
        };
        let onUp = () =>
        {
            if (!inputDown) return;
            if (onDragEnd) onDragEnd(prevInputPos.x - initialInputPos.x, prevInputPos.y - initialInputPos.y, prevInputPos.x, prevInputPos.y);
            prevInputPos = null;
            inputDown = false;
        };

        var inputDown = false;
        var prevInputPos;
        var initialInputPos = prevInputPos = null;

        let canvas = document.getElementById("contentWrapper");
        let sceneUpdate = scene.update.bind(scene);
        scene.update = function (time, delta)
        {
            sceneUpdate(time, delta);
            if (inputDown)
            {
                let pos = getPos();
                if (onDrag && prevInputPos) 
                {
                    if (!prevInputPos) onDrag(0, 0, pos.x, pos.y, time, delta);
                    else onDrag(pos.x - prevInputPos.x, pos.y - prevInputPos.y, pos.x, pos.y, time, delta);
                }
                prevInputPos = pos;
            }
        };

        canvas.onmouseleave = onUp;
        canvas.onmouseup = onUp;
        canvas.onmousedown = onDown;

        canvas.ontouchcancel = onUp;
        canvas.ontouchstart = onDown;
        canvas.ontouchend = onUp;

        Utils.scene.sys.events.on("shutdown", () =>
        {
            canvas.onmouseleave = null;
            canvas.onmouseup = null;
            canvas.onmousedown = null;

            canvas.ontouchcancel = null;
            canvas.ontouchstart = null;
            canvas.ontouchend = null;
        });
    }

    /**
     * @param {InputHelper.KeyCodes} keyCode 
     */
    static GetCharacter(keyCode, isShifted)
    {
        if (!this.charMap_Normal) this.initcharMaps();
        return (isShifted) ? this.charMap_Shift[keyCode] : this.charMap_Normal[keyCode];
    }

    /**
     * @param {function(InputHelper.KeyCodes, Boolean, Boolean, Boolean)} func (InputHelper.KeyCodes, ctrlDown, altDown, shiftDown)
     */
    static GetKeyCodes(func, event = 'keydown', preventDefault = false)
    {
        window.addEventListener(event, (e) =>
        {
            if (preventDefault) e.preventDefault();
        }, false);
        Utils.scene.input.keyboard.on(event, (event) =>
        {
            func(event.keyCode, event.ctrlKey, event.altKey, event.shiftKey);
            if (preventDefault) event.preventDefault();
        });
    }

    static initcharMaps()
    {
        this.charMap_Shift = [];
        this.charMap_Shift[8] = "";
        this.charMap_Shift[9] = "";
        this.charMap_Shift[13] = "\n";
        this.charMap_Shift[16] = "";
        this.charMap_Shift[17] = "";
        this.charMap_Shift[18] = "";
        this.charMap_Shift[19] = "";
        this.charMap_Shift[20] = "";
        this.charMap_Shift[27] = "";
        this.charMap_Shift[32] = " ";
        this.charMap_Shift[33] = "";
        this.charMap_Shift[34] = "";
        this.charMap_Shift[35] = "";
        this.charMap_Shift[36] = "";
        this.charMap_Shift[37] = "";
        this.charMap_Shift[38] = "";
        this.charMap_Shift[39] = "";
        this.charMap_Shift[40] = "";
        this.charMap_Shift[45] = "";
        this.charMap_Shift[46] = "";
        this.charMap_Shift[48] = ")";
        this.charMap_Shift[49] = "!";
        this.charMap_Shift[50] = "@";
        this.charMap_Shift[51] = "#";
        this.charMap_Shift[52] = "$";
        this.charMap_Shift[53] = "%";
        this.charMap_Shift[54] = "^";
        this.charMap_Shift[55] = "&";
        this.charMap_Shift[56] = "*";
        this.charMap_Shift[57] = "(";
        this.charMap_Shift[59] = ":";
        this.charMap_Shift[61] = "+";
        this.charMap_Shift[65] = "A";
        this.charMap_Shift[66] = "B";
        this.charMap_Shift[67] = "C";
        this.charMap_Shift[68] = "D";
        this.charMap_Shift[69] = "E";
        this.charMap_Shift[70] = "F";
        this.charMap_Shift[71] = "G";
        this.charMap_Shift[72] = "H";
        this.charMap_Shift[73] = "I";
        this.charMap_Shift[74] = "J";
        this.charMap_Shift[75] = "K";
        this.charMap_Shift[76] = "L";
        this.charMap_Shift[77] = "M";
        this.charMap_Shift[78] = "N";
        this.charMap_Shift[79] = "O";
        this.charMap_Shift[80] = "P";
        this.charMap_Shift[81] = "Q";
        this.charMap_Shift[82] = "R";
        this.charMap_Shift[83] = "S";
        this.charMap_Shift[84] = "T";
        this.charMap_Shift[85] = "U";
        this.charMap_Shift[86] = "V";
        this.charMap_Shift[87] = "W";
        this.charMap_Shift[88] = "X";
        this.charMap_Shift[89] = "Y";
        this.charMap_Shift[90] = "Z";
        this.charMap_Shift[91] = "";
        this.charMap_Shift[92] = "";
        this.charMap_Shift[93] = "";
        this.charMap_Shift[96] = "0";
        this.charMap_Shift[97] = "1";
        this.charMap_Shift[98] = "2";
        this.charMap_Shift[99] = "3";
        this.charMap_Shift[100] = "4";
        this.charMap_Shift[101] = "5";
        this.charMap_Shift[102] = "6";
        this.charMap_Shift[103] = "7";
        this.charMap_Shift[104] = "8";
        this.charMap_Shift[105] = "9";
        this.charMap_Shift[106] = "*";
        this.charMap_Shift[107] = "+";
        this.charMap_Shift[109] = "_";
        this.charMap_Shift[107] = "+";
        this.charMap_Shift[111] = "/";
        this.charMap_Shift[112] = "";
        this.charMap_Shift[113] = "";
        this.charMap_Shift[114] = "";
        this.charMap_Shift[115] = "";
        this.charMap_Shift[116] = "";
        this.charMap_Shift[117] = "";
        this.charMap_Shift[118] = "";
        this.charMap_Shift[119] = "";
        this.charMap_Shift[120] = "";
        this.charMap_Shift[121] = "";
        this.charMap_Shift[122] = "";
        this.charMap_Shift[123] = "";
        this.charMap_Shift[144] = "";
        this.charMap_Shift[145] = "";
        this.charMap_Shift[186] = ":";
        this.charMap_Shift[187] = "+";
        this.charMap_Shift[188] = "<";
        this.charMap_Shift[189] = "_";
        this.charMap_Shift[190] = ">";
        this.charMap_Shift[191] = "?";
        this.charMap_Shift[192] = "~";
        this.charMap_Shift[219] = "{";
        this.charMap_Shift[220] = "|";
        this.charMap_Shift[221] = "}";
        this.charMap_Shift[222] = "\"";

        this.charMap_Normal = [];
        this.charMap_Normal[8] = "";
        this.charMap_Normal[9] = "";
        this.charMap_Normal[13] = "\n";
        this.charMap_Normal[16] = "";
        this.charMap_Normal[17] = "";
        this.charMap_Normal[18] = "";
        this.charMap_Normal[19] = "";
        this.charMap_Normal[20] = "";
        this.charMap_Normal[27] = "";
        this.charMap_Normal[32] = " ";
        this.charMap_Normal[33] = "";
        this.charMap_Normal[34] = "";
        this.charMap_Normal[35] = "";
        this.charMap_Normal[36] = "";
        this.charMap_Normal[37] = "";
        this.charMap_Normal[38] = "";
        this.charMap_Normal[39] = "";
        this.charMap_Normal[40] = "";
        this.charMap_Normal[45] = "";
        this.charMap_Normal[46] = "";
        this.charMap_Normal[48] = "0";
        this.charMap_Normal[49] = "1";
        this.charMap_Normal[50] = "2";
        this.charMap_Normal[51] = "3";
        this.charMap_Normal[52] = "4";
        this.charMap_Normal[53] = "5";
        this.charMap_Normal[54] = "6";
        this.charMap_Normal[55] = "7";
        this.charMap_Normal[56] = "8";
        this.charMap_Normal[57] = "9";
        this.charMap_Normal[59] = ";";
        this.charMap_Normal[61] = "=";
        this.charMap_Normal[65] = "a";
        this.charMap_Normal[66] = "b";
        this.charMap_Normal[67] = "c";
        this.charMap_Normal[68] = "d";
        this.charMap_Normal[69] = "e";
        this.charMap_Normal[70] = "f";
        this.charMap_Normal[71] = "g";
        this.charMap_Normal[72] = "h";
        this.charMap_Normal[73] = "i";
        this.charMap_Normal[74] = "j";
        this.charMap_Normal[75] = "k";
        this.charMap_Normal[76] = "l";
        this.charMap_Normal[77] = "m";
        this.charMap_Normal[78] = "n";
        this.charMap_Normal[79] = "o";
        this.charMap_Normal[80] = "p";
        this.charMap_Normal[81] = "q";
        this.charMap_Normal[82] = "r";
        this.charMap_Normal[83] = "s";
        this.charMap_Normal[84] = "t";
        this.charMap_Normal[85] = "u";
        this.charMap_Normal[86] = "v";
        this.charMap_Normal[87] = "w";
        this.charMap_Normal[88] = "x";
        this.charMap_Normal[89] = "y";
        this.charMap_Normal[90] = "z";
        this.charMap_Normal[91] = "";
        this.charMap_Normal[92] = "";
        this.charMap_Normal[93] = "";
        this.charMap_Normal[96] = "0";
        this.charMap_Normal[97] = "1";
        this.charMap_Normal[98] = "2";
        this.charMap_Normal[99] = "3";
        this.charMap_Normal[100] = "4";
        this.charMap_Normal[101] = "5";
        this.charMap_Normal[102] = "6";
        this.charMap_Normal[103] = "7";
        this.charMap_Normal[104] = "8";
        this.charMap_Normal[105] = "9";
        this.charMap_Normal[106] = "*";
        this.charMap_Normal[107] = "+";
        this.charMap_Normal[109] = "_";
        this.charMap_Normal[107] = "+";
        this.charMap_Normal[111] = "/";
        this.charMap_Normal[112] = "";
        this.charMap_Normal[113] = "";
        this.charMap_Normal[114] = "";
        this.charMap_Normal[115] = "";
        this.charMap_Normal[116] = "";
        this.charMap_Normal[117] = "";
        this.charMap_Normal[118] = "";
        this.charMap_Normal[119] = "";
        this.charMap_Normal[120] = "";
        this.charMap_Normal[121] = "";
        this.charMap_Normal[122] = "";
        this.charMap_Normal[123] = "";
        this.charMap_Normal[144] = "";
        this.charMap_Normal[145] = "";
        this.charMap_Normal[186] = ";";
        this.charMap_Normal[187] = "=";
        this.charMap_Normal[188] = ",";
        this.charMap_Normal[189] = "-";
        this.charMap_Normal[190] = ".";
        this.charMap_Normal[191] = "/";
        this.charMap_Normal[192] = "`";
        this.charMap_Normal[219] = "[";
        this.charMap_Normal[220] = "\\";
        this.charMap_Normal[221] = "]";
        this.charMap_Normal[222] = "'";
    }
}